module.exports = __webpack_public_path__ + "assets/img/logo-italia-solare.c0950db4.png";